import b from 'b_';
import { format } from 'date-fns';
import { SimpleCallback, Text } from 'platform-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import AssignLessonPanel from 'common.components/lesson-view.assignment/assignment';
import * as lessonSelectors from 'common.components/lesson/selectors';
import ScrollBlock from 'common.components/scroll-block/scroll-block';

import ActionButton from '../__action-button/side-panel__action-button';
import AssignHeaderDesktop from '../__assign-header/side-panel__assign-header_desktop';
import AssignHeaderMobile from '../__assign-header/side-panel__assign-header_mobile';
import { Controls } from '../__controls/side-panel__controls';
import { SidePanelFooter } from '../__footer/side-panel__footer';
import { SidePanelHeader } from '../__header/side-panel__header';
import * as selectors from '../selectors';

interface Props {
    isExpanded: boolean;
    onForceComplete?: SimpleCallback;
    isCopyingEnabled?: boolean;
    isMobile: boolean;
}

export const SidePanelModeAssignment = React.memo((props: Props) => {
    const { isCopyingEnabled, isExpanded, isMobile, onForceComplete } = props;
    const currentCourseId = useSelector(getCurrentYearCourseId);
    const shouldShowSubscriptionWarning = useSelector((store) => {
        return selectors.getShouldShowSubscriptionWarning(store, { courseId: currentCourseId });
    });
    const subscriptionSlug = useSelector((store) =>
        lessonSelectors.getLessonActiveSubscriptionSlug(store, { courseId: currentCourseId })
    );

    const subscription = useSelector((store) =>
        lessonSelectors.getSubscriptionBySlug(store, { slug: subscriptionSlug })
    );
    let date = '';

    if (shouldShowSubscriptionWarning && subscription) {
        date = format(new Date(subscription.delivery_dt), 'dd.MM');
    }

    return (
        <>
            <SidePanelHeader isExpanded={isExpanded}>
                {isMobile ? <AssignHeaderMobile /> : <AssignHeaderDesktop />}
            </SidePanelHeader>
            <ScrollBlock mix={b('side-panel', 'scroll-block', { expanded: isExpanded })}>
                <div className="side-panel__content">
                    <AssignLessonPanel />
                </div>
            </ScrollBlock>
            <SidePanelFooter>
                <div className="side-panel__footer-controls">
                    <ActionButton onForceComplete={onForceComplete} />
                    <Controls isCopyingEnabled={isCopyingEnabled} isMobile={isMobile} />
                </div>
                {shouldShowSubscriptionWarning && (
                    <div className="side-panel__warning">
                        <Text
                            id="lessonView.sidePanel.subscriptionWarning"
                            type={Text.TYPE.MARKDOWN}
                            values={{ date }}
                        />
                    </div>
                )}
            </SidePanelFooter>
        </>
    );
});
